export default "__VITE_ASSET__B9dQDuKK__"